import React from 'react';
import styled from 'styled-components';
import { Flex } from "@xingternal/winery-ui/lib/UI";

const VERTICAL_SPACE_TOP_EDGE_TO_CANDIDATES = 217;
const PAGE_BOTTOM_MARGIN = 24;
const TOP_SPACE = VERTICAL_SPACE_TOP_EDGE_TO_CANDIDATES + PAGE_BOTTOM_MARGIN;

type Props = {
  children: React.ReactNode;
} & React.HTMLAttributes<HTMLDivElement>;

/**
 * ScrollingWrapper: outer box that contains the whole list, defining the flexible height,
 * and provides scrollbars
 */
const InnerScrollingWrapper = styled(Flex)`
  overflow-x: auto;
  overflow-y: auto;
  height: -ms-calc(100vh - ${TOP_SPACE}px); /* microsoft */
  height: calc(100vh - ${TOP_SPACE}px);
  flex-direction: column; // makes notes part to have scroll with flexible height
  flex-wrap: wrap; // makes notes part 100% width
`;

/**
 * ScrollingWrapper provides a DOM container with x/y scroll bars
 */
const ScrollingWrapper = ({ children, ...rest }: Props) => (
  <InnerScrollingWrapper {...rest}>{children}</InnerScrollingWrapper>
);

export { ScrollingWrapper };
